'use strict';

var _ = require('lodash');
var template = _.template(require('../templates/legend-item-tooltip.html'));
var ChartForecastProfileViewDataProviderService = function ChartForecastProfileViewDataProviderService(dataRetrieverService, profileLevelStrategyProvider, colorScales, momentService, chartConstants, userPreferencesService, daysToDepartureCalculatorService, demandTransparencyConstants) {
  var colors = colorScales.colorScale1();
  function getDateLineData(departureDate, airportTimeZoneData, datesToCompare) {
    return datesToCompare.map(function (date) {
      var dtd = daysToDepartureCalculatorService.calculate(date.value, airportTimeZoneData, departureDate);
      return {
        dtd: dtd,
        caption: [date.caption, dtd, 'DTD'].join(' '),
        className: date.className,
        textAnchor: date.anchor,
        color: date.color
      };
    });
  }
  function getLegendItemTooltip(sourceKey, targetKey) {
    return template({
      tooltip: {
        title: 'Profile Source',
        contents: [{
          label: 'Target',
          txt: targetKey
        }, {
          label: 'Source',
          txt: sourceKey
        }]
      }
    });
  }
  function transformData(profilesData, quickFilterData, attrs) {
    var targetStrategy = profileLevelStrategyProvider.getStrategy(attrs.targetProfileLevel);
    var result = [];
    var processed = {};
    var legendMapped = [];
    var index = 0;
    var singleProfile = _.size(profilesData) === 1;
    profilesData.forEach(function (profile) {
      var season = profile.season || attrs.season;
      var dowGroup = profile.dayOfWeekGroup || attrs.dowGroup;
      var profileLevel = profile.profileLevel;
      var profileStrategy = profileLevelStrategyProvider.getStrategy(profileLevel);
      var profileMatched = targetStrategy.profileMatched(quickFilterData, season, dowGroup);
      var profileKey = profileStrategy.getLabel(season, dowGroup);
      var targetKey = targetStrategy.getLabel(season, dowGroup);
      var isDifferentFromProfile = profileKey !== targetKey;
      if (singleProfile || profileMatched && !processed[profileKey]) {
        var color = colors(index);
        legendMapped.push({
          id: index,
          label: profileKey,
          fill: color,
          labelItalic: isDifferentFromProfile,
          tooltip: getLegendItemTooltip(profileKey, targetKey)
        });
        result.push({
          caption: profile.classGroup,
          season: season,
          dayOfWeekGroup: dowGroup,
          dotted: false,
          fill: color,
          curveData: profile.curveData,
          source: demandTransparencyConstants.PROFILE_LEVEL_MAPPING[profileLevel],
          target: targetKey,
          isDifferentFromProfile: isDifferentFromProfile
        });
        index++;
        processed[profileKey] = true;
      }
    });
    var lastProcessedUTC = momentService.copy(attrs.lastProcessedMoment, momentService.TYPE.LOCAL_DATE_TIME);
    var nowUTC = momentService.now(momentService.FIELD.DEPARTURE_DATE);
    var anchorNow = 'end';
    var anchorLp = 'start';
    if (userPreferencesService.getUserDateTimeSettings('defaultRTPView') === chartConstants.DIRECTION.RTL) {
      anchorNow = 'start';
      anchorLp = 'end';
    }
    var verticalLineData = getDateLineData(attrs.departureDate, attrs.airportTimeZoneData, [{
      value: nowUTC,
      caption: 'Today:',
      className: 'gte-today-line',
      anchor: anchorNow,
      color: '#247ae4'
    }, {
      value: lastProcessedUTC,
      caption: 'Last Processed:',
      className: 'dashed gte-last-processed-line',
      anchor: anchorLp
    }]);
    return {
      data: result,
      legend: legendMapped,
      verticalLineData: verticalLineData
    };
  }
  function getData(attrs, quickFilterData, dataDimension) {
    return dataRetrieverService.getForecastProfileData(attrs, quickFilterData, dataDimension).then(function (data) {
      return transformData(data, quickFilterData, attrs);
    });
  }
  return {
    getData: getData
  };
};
ChartForecastProfileViewDataProviderService.$inject = ['DemandTransparencyDataRetrieverService', 'ProfileLevelStrategyProviderService', 'RmColorScales', 'MomentService', 'ChartElementsConstants', 'UserPreferencesService', 'DaysToDepartureCalculatorService', 'DemandTransparencyConstants'];
module.exports = ChartForecastProfileViewDataProviderService;